import { ApplicationStatus } from '../types';

// The interview stages where prepping for an upcoming conversation makes sense.
// The backend does NOT enforce stage — this gating is purely ours, so the
// "Generate interview kit" affordance appears at the right moment. Earlier
// stages (submitted / under_review) have no interview yet; terminal stages
// (hired / rejected / withdrawn / offer_extended / negotiation) have no
// interview left to prep for. We keep it through reference_check.
const INTERVIEW_KIT_STATUSES: ReadonlySet<ApplicationStatus> = new Set<ApplicationStatus>([
  'screening_call',
  'first_interview',
  'second_interview',
  'additional_interview',
  'technical_assessment',
  'reference_check',
]);

export const canGenerateInterviewKit = (status: ApplicationStatus): boolean =>
  INTERVIEW_KIT_STATUSES.has(status);

// Short, human label for the interview stage — shown in the kit modal's
// "file" metadata line. Falls back to a generic "Interview" for any status
// that isn't a known interview stage.
const STAGE_LABELS: Partial<Record<ApplicationStatus, string>> = {
  screening_call: 'Screening',
  first_interview: 'First interview',
  second_interview: 'Second interview',
  additional_interview: 'Interview',
  technical_assessment: 'Technical interview',
  reference_check: 'Reference check',
};

export const interviewStageLabel = (status: ApplicationStatus): string =>
  STAGE_LABELS[status] ?? 'Interview';

// A short, stable "case file" token derived from the application id — purely
// decorative dossier flavor (e.g. "JB-1A2B"). Real, not fabricated.
export const interviewKitFileNo = (applicationId: string): string => {
  const tail = applicationId.replace(/[^a-z0-9]/gi, '').slice(-4).toUpperCase();
  return `JB-${tail || '0000'}`;
};
